import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {environment} from "../../environments/environment";

interface TokenValidationResponse {
  data: {
    token: string;
  };
  metadata: {
    message: string;
  };
}

interface OptOutResponse {
  data: {
    email_address: string;
  };
  metadata: {
    message: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class GdprNoticeService {

  private apiUrl = environment.api.url;

  constructor(private http: HttpClient) {}

  validateToken(token: string): Observable<{ message: string }> {

    const url = `${this.apiUrl}/gdpr_notice/token/validate`;

    const requestBody = {token: token};

    return this.http.post<TokenValidationResponse>(url, requestBody).pipe(
      map(response => {
        if (!response.metadata || !response.metadata.message) {
          throw new Error('Token validation failed: No message received');
        }
        return { message: response.metadata.message };
      }),
      catchError(error => {
        console.error('Token validation request failed:', error);
        return throwError(() => new Error('Token validation failed'));
      })
    );
  }

  optOut(token: string): Observable<{ message: string }> {
    const url = `${this.apiUrl}/gdpr_notice/add_to_blacklist`;
    const requestBody = { token };

    return this.http.post<OptOutResponse>(url, requestBody, { observe: 'response' }).pipe(
      map(response => {
        if (response.status === 200 && response.body) {
          return { message: response.body.metadata.message };
        } else {
          // This throws an error to be caught in the catchError below
          throw new Error(`Opt-out failed: ${response.body ? response.body.metadata.message : 'No message received'}`);
        }
      }),
      catchError(error => {
        // console.error('Opt-out request failed:', error);
        // return throwError(() => new Error(`Opt-out failed: ${error.message || 'Unknown error'}`));
        throw error;
      })
    );
  }

}
